import React, { FC, useState } from 'react';
import CustomersTableHead from './components/CustomersTableHead';
import { Table, TableBody, TableCell, TableContainer, TablePagination, TableRow } from '@material-ui/core';
import { createUseStyles } from '../../../../../../theming';
import { HeadCell, Order } from '../../../../../../interfaces/Table';
import { LegacyCustomer } from '../../../../../../interfaces/api/Customer';
import { Link } from 'react-router-dom';

const useStyles = createUseStyles({
  root: ({ maxHeight }) => ({
    maxHeight,
  }),
});

const customersHeadCells: HeadCell<LegacyCustomer>[] = [
  { id: 'installationSite', numeric: false, label: 'Raison sociale' },
  { id: 'dateCreate', numeric: true, label: 'Date de création' },
];

interface Props {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof LegacyCustomer) => void;
  customers: LegacyCustomer[];
  maxHeight: number;
  orderBy: keyof LegacyCustomer;
  order: Order;
}

const CustomersTable: FC<Props> = ({ onRequestSort, maxHeight, customers, order, orderBy }) => {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const classes = useStyles({ maxHeight: maxHeight - 200 });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer className={classes.root}>
      <Table>
        <CustomersTableHead
          order={order}
          orderBy={orderBy}
          headCells={customersHeadCells}
          onRequestSort={onRequestSort}
        />
        <TableBody>
          {customers.length <= 0 && (
            <TableRow>
              <TableCell colSpan={customersHeadCells.length}>Aucun client trouvé ...</TableCell>
            </TableRow>
          )}
          {customers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((customer, index) => (
            <TableRow hover tabIndex={-1} key={index}>
              <TableCell>
                <Link to={`/dashboard/customer/${customer.id}`}>{customer.installationSite?.socialReason || ''}</Link>
              </TableCell>
              <TableCell align='right'>{customer.dateCreate}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        count={customers.length}
        component='div'
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default CustomersTable;
